module.exports = __webpack_public_path__ + "img/s3Model2.f07edb30.webp";